module.exports = __webpack_public_path__ + "img/disableWhatApp.a9891dd2.png";